import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { map, Observable, of, take } from 'rxjs';
import { AuthService } from './auth.service';
import { TokenService } from '../core/token.service';
import { Buffer } from 'buffer';
import { DOCUMENT } from '@angular/common';
import { ErrorDialogComponent } from '../core/http-interceptors/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate {
  signInUrlTree = this.router.parseUrl('/sign-in');

  constructor(
    private router: Router,
    private token: TokenService,
    private auth: AuthService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    @Inject(DOCUMENT) private document: any
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    // const queriesParam =route.queryParams;
    const token = route.queryParams['token'];
    const ok = route.queryParams['ok'];
    const queries = new URLSearchParams(this.document.location.search);
    if (token) {
      const decodedToken = JSON.parse(
        Buffer.from(token, 'base64').toString('ascii')
      );
      if (ok === '1') {
        this.token.persist(decodedToken);
      } else {
        this.token.clear();
        this.dialog.open(ErrorDialogComponent, {
          data: decodedToken,
          position: { bottom: '24px' },
          panelClass: 'error-dialog',
          hasBackdrop: false,
        });
      }
    }
    queries.delete('token');
    queries.delete('ok');
    return this.auth.isAuthenticated.pipe(
      take(1),
      map((isAuthenticated) => {
        const currentOrigin = this.document.location.origin;
        const currentPath =
          this.document.location.pathname === '/sign-in'
            ? '/dashboard'
            : this.document.location.pathname;

        const signInUrlTree = this.router.parseUrl(
          `/sign-in?returnUrl=${currentOrigin}${currentPath}?${queries.toString()}`
        );

        return !!isAuthenticated || signInUrlTree;
      })
    );
  }
}
